var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLoyalty(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 440,
    height: 400,
    viewBox: "0 0 440 400",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.4551 64.8015H40.9746V84.3088L29.4925 72.8339L21.4551 64.8015Z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M105.792 136.18C99.8095 145.318 89.3408 151.269 77.5902 151.269C59.003 151.269 43.834 136.18 43.834 117.69C43.834 99.2007 59.003 84.1113 77.5902 84.1113C89.3408 84.1113 99.8095 90.062 105.792 99.2007",
    fill: "none"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M105.792 136.18C99.8095 145.318 89.3408 151.269 77.5902 151.269C59.003 151.269 43.834 136.18 43.834 117.69C43.834 99.2007 59.003 84.1113 77.5902 84.1113C89.3408 84.1113 99.8095 90.062 105.792 99.2007",
    stroke: "currentColor",
    strokeWidth: 5.87099,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M91.048 104.302C88.6979 102.39 85.2795 101.54 81.2203 101.54H68.4015V125.767H63.7012V128.317V130.23H68.4015V133.843H73.1017V130.23H83.1431V128.317V125.767H73.1017V123.005H81.2203C85.4932 123.005 88.6979 122.154 91.048 120.242C93.3981 118.329 94.68 115.779 94.68 112.166C94.68 108.765 93.3981 106.215 91.048 104.302ZM87.6297 117.479C86.1342 118.754 83.9977 119.392 81.0066 119.392H72.8881V105.578H81.2203C83.9977 105.578 86.3478 106.215 87.8433 107.278C89.3389 108.553 90.1934 110.041 90.1934 112.378C89.9798 114.504 89.1252 116.204 87.6297 117.479Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M77.5936 146.168C93.4047 146.168 106.222 133.418 106.222 117.69C106.222 101.962 93.4047 89.2114 77.5936 89.2114C61.7823 89.2114 48.9648 101.962 48.9648 117.69C48.9648 133.418 61.7823 146.168 77.5936 146.168Z",
    stroke: "currentColor",
    strokeWidth: 2.20162,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M302.655 393.003H130.972C116.941 393.003 105.66 381.782 105.66 367.824V55.0004V28.1792C105.66 14.2212 116.941 3 130.972 3H302.655C316.686 3 327.967 14.2212 327.967 28.1792V367.824C327.967 381.508 316.686 393.003 302.655 393.003Z",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 5.57067,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M130.978 377.397C125.751 377.397 121.35 373.019 121.35 367.818V28.1736C121.35 22.9736 125.751 18.5946 130.978 18.5946H302.661C307.889 18.5946 312.291 22.9736 312.291 28.1736V367.818C312.291 373.019 307.889 377.397 302.661 377.397H130.978Z",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2.09091,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M130.977 369.737C129.876 369.737 129.051 368.916 129.051 367.822V28.1767C129.051 27.0819 129.876 26.2609 130.977 26.2609H302.658C303.759 26.2609 304.584 27.0819 304.584 28.1767V367.822C304.584 368.916 303.759 369.737 302.658 369.737H130.977Z",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2.09091,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M105.66 54.9949H327.967",
    stroke: "currentColor",
    strokeWidth: 5.57067,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M105.66 338.811H327.967",
    stroke: "currentColor",
    strokeWidth: 7.5605,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M195.084 359.061H238.555",
    stroke: "currentColor",
    strokeWidth: 7.5605,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M392.026 227.758H375.805V288.717H392.026V227.758Z",
    fill: "none"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M363.493 254.501H347.172V290.578H363.493V254.501Z",
    fill: "none"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M200.856 196.49C208.758 196.49 215.163 190.118 215.163 182.259C215.163 174.399 208.758 168.028 200.856 168.028C192.955 168.028 186.549 174.399 186.549 182.259C186.549 190.118 192.955 196.49 200.856 196.49Z",
    stroke: "currentColor",
    strokeWidth: 7.5605,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M200.859 188.562C204.354 188.562 207.187 185.744 207.187 182.267C207.187 178.79 204.354 175.973 200.859 175.973C197.364 175.973 194.531 178.79 194.531 182.267C194.531 185.744 197.364 188.562 200.859 188.562Z",
    stroke: "currentColor",
    strokeWidth: 2.83519,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M234.702 242.203C242.603 242.203 249.009 235.831 249.009 227.971C249.009 220.111 242.603 213.739 234.702 213.739C226.801 213.739 220.395 220.111 220.395 227.971C220.395 235.831 226.801 242.203 234.702 242.203Z",
    stroke: "currentColor",
    strokeWidth: 7.5605,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M234.7 234.264C238.195 234.264 241.028 231.447 241.028 227.97C241.028 224.493 238.195 221.675 234.7 221.675C231.204 221.675 228.371 224.493 228.371 227.97C228.371 231.447 231.204 234.264 234.7 234.264Z",
    stroke: "currentColor",
    strokeWidth: 2.83519,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M246.253 175.973L181.047 240.562",
    stroke: "currentColor",
    strokeWidth: 7.5605,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M291.652 206.35C291.652 212.645 284.223 218.118 282.573 223.865C280.921 229.887 284.773 238.372 281.747 243.571C278.721 249.045 269.366 249.866 264.963 254.245C260.562 258.624 259.736 267.655 254.234 270.94C249.006 273.951 240.478 270.119 234.424 271.76C228.646 273.403 223.144 280.793 216.816 280.793C210.488 280.793 204.985 273.403 199.208 271.76C193.154 270.119 184.625 273.951 179.398 270.94C173.896 267.93 173.069 258.624 168.668 254.245C164.266 249.866 155.186 249.045 151.885 243.571C148.858 238.372 152.71 229.887 151.059 223.865C149.409 218.118 141.98 212.645 141.98 206.35C141.98 200.056 149.409 194.582 151.059 188.834C152.71 182.812 148.858 174.329 151.885 169.128C154.911 163.654 164.266 162.834 168.668 158.455C173.069 154.075 173.896 145.044 179.398 141.759C184.625 138.749 193.154 142.581 199.208 140.939C204.985 139.297 210.488 131.907 216.816 131.907C223.144 131.907 228.646 139.297 234.424 140.939C240.478 142.581 249.006 138.749 254.234 141.759C259.736 144.771 260.562 154.075 264.963 158.455C269.366 162.834 278.445 163.654 281.747 169.128C284.773 174.329 280.921 182.812 282.573 188.834C284.223 194.855 291.652 200.056 291.652 206.35Z",
    stroke: "currentColor",
    strokeWidth: 7.5605,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M216.823 273.133C211.046 273.133 206.369 265.744 201.141 264.375C195.638 263.007 187.934 266.838 183.257 264.101C178.306 261.364 178.03 252.607 174.178 248.775C170.326 244.943 161.522 244.67 158.77 239.744C156.019 235.091 160.147 227.428 158.496 221.954C157.12 216.753 149.691 212.101 149.691 206.354C149.691 200.606 157.12 195.954 158.496 190.753C159.871 185.28 156.019 177.617 158.77 172.964C161.522 168.038 170.326 167.763 174.178 163.932C178.03 160.1 178.306 151.342 183.257 148.605C187.934 145.868 195.638 149.974 201.141 148.332C206.369 146.963 211.046 139.574 216.823 139.574C222.601 139.574 227.278 146.963 232.506 148.332C238.009 149.7 245.713 145.868 250.39 148.605C255.342 151.342 255.617 160.1 259.469 163.932C263.321 167.763 272.126 168.038 274.877 172.964C277.628 177.617 273.501 185.28 275.151 190.753C276.527 195.954 283.956 200.606 283.956 206.354C283.956 212.101 276.527 216.753 275.151 221.954C273.776 227.428 277.628 235.091 274.877 239.744C272.126 244.67 263.321 244.943 259.469 248.775C255.617 252.607 255.342 261.364 250.39 264.101C245.713 266.838 238.009 262.733 232.506 264.375C227.278 265.744 222.601 273.133 216.823 273.133Z",
    stroke: "currentColor",
    strokeWidth: 2.83519,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M66.693 184.638C75.4526 185.913 84.2122 185.276 92.7581 182.938C93.399 182.726 94.04 182.087 94.2536 181.45C94.4674 180.813 94.2536 179.962 93.6127 179.325C92.9718 178.688 92.3308 178.688 91.4763 178.688C83.3576 180.813 75.239 181.238 66.9066 180.175C50.4556 178.05 35.7139 169.337 25.6723 156.159C15.6308 142.983 11.1442 126.618 13.4943 110.254C15.2035 97.7148 20.5447 86.0258 29.3044 76.6747L29.7317 76.2497L40.4141 86.451C41.0551 87.0885 41.9096 87.301 42.7642 86.876C43.6189 86.451 44.0461 85.8133 44.0461 84.9633L44.2597 63.9231C44.2597 63.2855 44.0461 62.8604 43.6189 62.4354C43.1916 62.0104 42.5506 61.7979 42.1234 61.7979L21.1857 62.6479C20.3311 62.6479 19.4765 63.2855 19.2628 63.9231C19.0492 64.5607 19.2628 65.6233 19.6902 66.2609L26.9542 73.2743L26.5269 73.6993C17.34 83.6881 11.3578 96.2271 9.64866 109.616C4.52108 146.171 30.3727 179.75 66.693 184.638ZM39.9869 66.6859V80.5002L26.3133 67.3236L39.9869 66.6859Z",
    fill: "currentColor"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M360.499 287.858H349.13V256.581C349.13 255.874 349.664 255.344 350.374 255.344H359.256C359.967 255.344 360.499 255.874 360.499 256.581V287.858ZM389.1 287.858H377.731V230.782C377.731 230.075 378.263 229.545 378.975 229.545H387.857C388.567 229.545 389.1 230.075 389.1 230.782V287.858ZM326.57 288.742V291.393H396.739C397.804 291.393 398.515 290.509 398.515 289.625C398.515 288.565 397.804 287.858 396.739 287.858H392.83V230.782C392.83 228.131 390.698 226.011 388.034 226.011H379.152C376.488 226.011 374.356 228.131 374.356 230.782V287.858H364.231V256.581C364.231 253.93 362.099 251.809 359.434 251.809H350.552C347.887 251.809 345.755 253.93 345.755 256.581V287.858H335.808V271.601C335.808 268.951 333.676 266.83 331.011 266.83H326.748V270.364H331.011C331.721 270.364 332.255 270.894 332.255 271.601V287.858H329.235H326.393H323.018L326.57 288.742Z",
    fill: "currentColor"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M392.652 201.447C392.652 200.917 392.474 200.387 392.119 200.034C391.763 199.68 391.23 199.503 390.697 199.503H379.861C378.795 199.503 378.085 200.387 378.085 201.271C378.085 202.331 378.973 203.038 379.861 203.038H386.612L368.848 220.709L362.097 213.994C361.742 213.64 361.386 213.464 360.854 213.464C360.321 213.464 359.966 213.64 359.611 213.994L327.28 246.155C326.568 246.862 326.568 247.921 327.28 248.628C327.635 248.982 328.168 249.159 328.523 249.159C329.056 249.159 329.411 248.982 329.766 248.628L360.854 217.704L367.604 224.419C368.314 225.126 369.381 225.126 370.091 224.419L389.277 205.336V211.343C389.277 212.403 390.165 213.11 391.052 213.11C391.94 213.11 392.829 212.226 392.829 211.343L392.652 201.447Z",
    fill: "currentColor"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M357.832 258.699H351.615V288.74H357.832V258.699Z",
    stroke: "currentColor",
    strokeWidth: 1.83058,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M326.57 273.72H329.235V287.857V288.74H326.57",
    stroke: "currentColor",
    strokeWidth: 1.83058,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M386.612 233.076H380.395V288.739H386.612V233.076Z",
    stroke: "currentColor",
    strokeWidth: 1.83058,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoyalty);
export default __webpack_public_path__ + "static/media/loyalty.9b78d962.svg";
export { ForwardRef as ReactComponent };